/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SchoolDropDown from './SchoolDropDown';

class SchoolsSelectComponent extends React.Component {
    static get props() {
        return {
            institutionList: PropTypes.array.isRequired,
            saveSelectedSchool: PropTypes.func.isRequired,
            currentUserGeo: PropTypes.string.isRequired
        };
    }

    constructor(props) {
        super(props);
        this.saveSelectedSchool = this.saveSelectedSchool.bind(this);
        this.state = {schoolList: this.props.institutionList};
    }

    saveSelectedSchool(selectedSchoolId) {
        if (selectedSchoolId && selectedSchoolId !== 'defaultOption') {
            this.props.saveSelectedSchool(selectedSchoolId);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({schoolList: nextProps.institutionList});
    }
    

    render() {
        return (
            <div>

                { (this.state.schoolList.length > 0)
                    && <div className="school-drop-down-wrapper">
                        <SchoolDropDown school={this.state.schoolList[0]}
                            disabled={false}
                            name="schools"
                            onChange={this.saveSelectedSchool}
                            options={this.state.schoolList}
                        />
                    </div>
                }
            </div>
        );
    }
}

export default SchoolsSelectComponent;



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/InstitutionChangeComponent/SchoolsSelectComponent.js